import { defineMessage } from '@lingui/macro'

import type { MessageDescriptor } from '@lingui/core'
import type { Content } from './content.type'

export const contentTypeTranslations: Record<Content['type'], MessageDescriptor> = {
  audio: defineMessage({ id: 'globals.audio', message: 'Audio' }),
  video: defineMessage({ id: 'globals.video', message: 'Video' }),
  article: defineMessage({ id: 'globals.article', message: 'Artikel' }),
}
